import React, { useEffect, useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import { ACCEPTED_FILE_TYPES } from 'config/accepted-file-types';
import DocumentUpload from './DocumentUpload';
import { FORM_ATME } from '../../../../config/documents';
import { useHandleUploadDocuments } from '../../../../utils/DocumentsHooks';
import { getFilesWithContentType } from 'utils/files/files';

export default function AccessorialUpload({
  docs,
  onFileUpload,
  onFileRemove,
  title,
  onUpload,
  atmeRequired = true,
}) {
  const { t } = useTranslation();

  const { handleUpload } = useHandleUploadDocuments(
    null,
    null,
    async (shipment, stop, type, uploadedData) => {
      const document =
        uploadedData && uploadedData.length > 0 ? uploadedData[0] : null;
      return onUpload?.(document);
    },
  );

  const [doName, setDoName] = useState('');
  const [atmeName, setAtmeName] = useState('');

  const dropzoneDO = useRef(null);
  const dropzoneATME = useRef(null);

  const hasDo = !_.isEmpty(doName);
  const hasAtme = !_.isEmpty(atmeName);

  const doLabel = t('DELIVERY_ORDER_DOC_NAME', { docName: doName });
  const atmeLabel = t('ATME', { atme: atmeName });

  useEffect(() => {
    setDoName(docs.do);
    setAtmeName(docs.atme);
  }, [docs]);

  const uploadTypesAlias = {
    do: 'delivery_order',
    atme: FORM_ATME.value,
  };

  const handleUploadDocuments = (files, docType) => {
    if (files && files.length) {
      const fileWithContentType = getFilesWithContentType(files);
      const file = fileWithContentType[0];
      if (docType === 'do') {
        setDoName(file.name);
      } else {
        setAtmeName(file.name);
      }
      handleUpload([file], uploadTypesAlias[docType]);
      onFileUpload(file, docType);
    }
  };

  const handleRemove = (docType) => {
    onFileRemove(docType);
  };

  const handleOpenDoZone = () => {
    dropzoneDO.current.open();
  };

  const handleOpenAtmeZone = () => {
    dropzoneATME.current.open();
  };

  return (
    <div className="max-w-md p-6 bg-white rounded shadow">
      <div className="mb-4 text-sm font-medium text-gray-500">
        {titleize(t(title))}
      </div>
      <div>
        {hasDo && (
          <DocumentUpload
            filename={doName}
            name={doLabel}
            onDelete={() => handleRemove('do')}
            className="mb-4"
          />
        )}
        {!hasDo && (
          <button
            className="mb-4 text-sm text-blue-500"
            onClick={handleOpenDoZone}
          >
            {t('UPLOAD_DELIVERY_ORDER')}
          </button>
        )}
      </div>
      {atmeRequired && (
        <div>
          {hasAtme && (
            <DocumentUpload
              filename={atmeName}
              name={atmeLabel}
              onDelete={() => handleRemove('atme')}
              className="mb-4"
            />
          )}
          {!hasAtme && (
            <button
              className="mb-4 text-sm text-blue-500"
              onClick={handleOpenAtmeZone}
            >
              {t('UPLOAD_ATME')}
            </button>
          )}
        </div>
      )}
      <Dropzone
        style={{ display: 'none' }}
        ref={(node) => {
          dropzoneDO.current = node;
        }}
        onDrop={(files) => handleUploadDocuments(files, 'do')}
        accept={ACCEPTED_FILE_TYPES}
      >
        {' '}
      </Dropzone>
      <Dropzone
        style={{ display: 'none' }}
        ref={(node) => {
          dropzoneATME.current = node;
        }}
        onDrop={(files) => handleUploadDocuments(files, 'atme')}
        accept={ACCEPTED_FILE_TYPES}
      >
        {' '}
      </Dropzone>
    </div>
  );
}
